import React, { useState, useEffect, useCallback } from "react";
import { Segment, Table, Radio, Image } from "semantic-ui-react";
import "./index.scss";
import notImageContent from "../../../assets/images/not_image.png";
import Shema from "./Shema";

const ImportProfile = ({
  providerProp,
  providersProp,
  changeProvider,
  notProperties
}) => {
  const [providers, setProviders] = useState([]);
  const [provider, setProvider] = useState("");
  const [modalShema, setModalSchema] = useState(false);
  const [properties, setProperties] = useState({});

  useEffect(() => {
    setProviders(providersProp);
  }, [providersProp]);

  useEffect(() => {
    setProvider(providerProp);
  }, [providerProp]);

  const changeCheckProvider = useCallback(
    (_, newValue) => {
      setProvider(newValue.value);
      changeProvider(newValue.value, newValue["data-provider"]);
    },
    [changeProvider]
  );

  const openConfigSchema = schema => {
    setProperties(schema.items.properties);
    setModalSchema(true);
  };

  return (
    <Segment attached="bottom">
      <Shema
        show={modalShema}
        handleClose={() => setModalSchema(false)}
        properties={properties}
      />
      <table className="table table-bordered">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Logo</Table.HeaderCell>
            <Table.HeaderCell>Compañía</Table.HeaderCell>
            <Table.HeaderCell>Descripción</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {providers.map((item, index) => {
            return (
              <Table.Row key={index}>
                <Table.Cell>
                  <Image
                    src={
                      item.logo && item.logo !== ""
                        ? "data:image/png;base64," + item.logo
                        : notImageContent
                    }
                    rounded
                    size="mini"
                  />
                </Table.Cell>
                <Table.Cell>
                  <p>{item.name}</p>
                </Table.Cell>
                <Table.Cell>
                  <p>{item.detail}</p>
                </Table.Cell>
                <Table.Cell>
                  <div className="import-profile__actions">
                    <Radio
                      onChange={changeCheckProvider}
                      toggle
                      value={item.providerId}
                      data-provider={item.provider}
                      checked={provider === item.providerId}
                    />
                    &nbsp;&nbsp;
                    {!notProperties ? (
                      <button
                        type="button"
                        onClick={() => openConfigSchema(item.schema)}
                        className="btn btn-inverse-primary btn-rounded btn-icon"
                      >
                        <i className="mdi mdi-eye"></i>
                      </button>
                    ) : null}
                  </div>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </table>
    </Segment>
  );
};

// Set default props
ImportProfile.defaultProps = {
  providerProp: "",
  providersProp: []
};

export default ImportProfile;
